export const RENT_STEP_OPTIONS = [
    { value: 1, label: 'Annual' },
    { value: 2, label: '2 yrs' },
    { value: 3, label: '3 yrs' },
    { value: 4, label: '4 yrs' },
    { value: 5, label: '5 yrs' },
    { value: 6, label: '6 yrs' },
    { value: 7, label: '7 yrs' },
    { value: 8, label: '8 yrs' },
    { value: 9, label: '9 yrs' },
    { value: 10, label: '10 yrs' },
];
